import React, { useState, useEffect } from "react";
import "../css/Navbar.css";
import userLogo from "../images/user.png";
import lupaBackground from "../images/Fondolupita.png";
import lupaIcon from "../images/LUPA2.png";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { get_productos ,setSearchTerm, setSelectedProductId, setSearchField } from "../redux/actions/productos";
import ProductoListaCarrito from "./ProductoListaCarrito ";
import Dropdown from "./Dropdown/Dropdown";
import DropdownItem from "./DropdownItem/DropdownItem";
import useFuzzySearch from "../hooks/useFuzzySearch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const SEARCH_FIELD_OPTIONS = [
  { label: 'Nombre', field: 'equipo' },
  { label: 'Marca', field: 'marca' },
  { label: 'Categoría', field: 'categoria' },
  { label: 'Sección', field: 'seccion' },
];

const Navbar = ({
  get_productos,
  productos,
  user,
  setSearchTerm,
  setSelectedProductId,
  searchField,
  setSearchField
}) => {

  const location = useLocation();
  const [searchTerm1, setSearchTerm1] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const fuzzySearch = useFuzzySearch(productos, searchField);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [get_productos]);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      setSearchTerm(event.target.value);
    }
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm1(value);
    setSearchTerm(value);
    setSelectedProductId(null);
    setSuggestions(value ? fuzzySearch(value) : []);
  };

  const handleSearchFieldChange = (field) => {
    setSearchField(field);
    setSearchTerm1("");
    setSearchTerm("");
    setSelectedProductId(null);
    setSuggestions([]);
  };

  const handleClearSearch = () => {
    setSearchTerm1("");
    setSearchTerm("");
    setSelectedProductId(null);
    setSuggestions([]);
  };

  const handleSuggestionClick = (producto) => {
    setSearchTerm1(producto.equipo);
    setSearchTerm(producto.equipo);
    setSelectedProductId(producto.id);
    setSuggestions([]);
    setIsFocused(false);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setTimeout(() => setIsFocused(false), 200); // Para permitir la selección del elemento de la lista
  };

  const pathsToShowSearch = ["/carroproductos", "/ListaProductos"];
  const shouldDisplaySearch = pathsToShowSearch.includes(location.pathname);

  return (
    <nav className="navbar">
      <section className="mt-0">
      </section>
      {shouldDisplaySearch && (
        <section className="search-section mt-0">
          <div className="search-container">
            <div className="search-input-wrapper">
              <input
                type="text"
                value={searchTerm1}
                onChange={handleSearchChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyDown={handleKeyPress}
                className="search-input"
                placeholder={isFocused ? "" : "¿Qué estás buscando?"}
                style={{ marginLeft: "10px" }} // Añade margen izquierdo al input
              />
              <img
                src={lupaBackground}
                alt="lupa background"
                className="lupa-background"
              />
              <img src={lupaIcon} alt="lupa icon" className="lupa-icon" />
              {searchTerm1 && (
                <button
                  type="button"
                  className="search-clear-btn"
                  onClick={handleClearSearch}
                  aria-label="Limpiar búsqueda"
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              )}
              <div className="search-field-dropdown">
                <Dropdown
                  buttonText={SEARCH_FIELD_OPTIONS.find(o => o.field === searchField)?.label || 'Nombre'}
                  content={
                    <>
                      {SEARCH_FIELD_OPTIONS.map(opt => (
                        <DropdownItem key={opt.field} onclick={() => handleSearchFieldChange(opt.field)}>
                          {opt.label}
                        </DropdownItem>
                      ))}
                    </>
                  }
                />
              </div>
              {isFocused && suggestions.length > 0 && (
              <ul className="autocomplete-suggestions">
                {suggestions.map((producto) => (
                  <li
                    key={producto.id}
                    className="suggestion-item"
                    onClick={() => handleSuggestionClick(producto)}
                  >
                    {producto.equipo}
                    {producto.marca && (
                      <span className="suggestion-marca"> - {producto.marca}</span>
                    )}
                  </li>
                ))}
              </ul>
              )}
            </div>
          </div>
        </section>
      )}
      <section className="informacion_navbar mt-0">
        {user && user !== null && user !== undefined ? (
          <span className="text-white mr-3 align-text-top user-name">{user.nombre}</span>
        ) : (
          <Link to="/">
            <span className="text-white mr-3">Iniciar sesión</span>
          </Link>
        )}
        <img className="img-logo" src={userLogo} alt="logo user" />
        <ProductoListaCarrito/>
      </section>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  user: state.Auth.user,
  productos: state.Productos.productos,
  searchField: state.Productos.searchField,
});
const mapDispatchToProps = {
  get_productos,
  setSearchTerm,
  setSelectedProductId,
  setSearchField,
};
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
